import { ButtonERP } from "@finanedi.es/storybook"
import FormikTextArea from "common/components/FormikFields/FormikTextArea"
import { useTranslation } from "react-i18next"

const AnnotationForm = ({
  handleBlur,
  values,
  onHide,
  handleChange,
  handleSubmit,
  errors,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  return (
    <form onSubmit={handleSubmit}>
      <div className='tw-mb-4'>
        <div className='tw-flex tw-flex-col tw-w-full'>
          <label htmlFor='descripcion'>{t("bancos.modal.taxtNote")}</label>
          <FormikTextArea
            id='descripcion'
            name='descripcion'
            value={values?.descripcion}
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder={`${t("bancos.modal.placeholderNote")}`}
            autoComplete='off'
          />
        </div>
      </div>
      <div>
        <div className='tw-flex tw-justify-end tw-items-center tw-gap-4 tw-mt-4'>
          <ButtonERP
            type='button'
            customize={{
              type: "white",
              size: "md",
            }}
            onClick={onHide}
            label={`${t("bancos.modal.cancelButton")}`}
          />
          <ButtonERP
            type='submit'
            disabled={errors && Boolean(Object.keys(errors)?.length)}
            customize={{
              type: "primary",
              size: "md",
            }}
            label={`${t("bancos.modal.saveButton")}`}
          />
        </div>
      </div>
    </form>
  )
}

export default AnnotationForm
